define('OutSystems/ReactView/Widget',["require", "exports", "tslib", "OutSystems/ClientRuntime/DataConversion", "OutSystems/ClientRuntime/DataTypes", "OutSystems/ClientRuntime/ObjectExtensions", "OutSystems/ClientRuntime/Utils", "OutSystems/ClientRuntime/Validation", "OutSystems/ClientRuntime/WidgetNaming", "prop-types", "react", "./BaseView", "./HtmlTags", "./WidgetHelpers", "./BaseView"], function (require, exports, tslib_1, DataConversion_1, DataTypes_1, ObjectExtensions, Utils_1, Validation_1, WidgetNaming_1, PropTypes, React, BaseView_1, HtmlTags_1, WidgetHelpers_1, BaseView_2) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.IteratorPlaceholderContent = exports.PlaceholderContent = exports.InputWithVariableWidget = exports.ValidationWidget = exports.Widget = exports.WidgetSpec = exports.executeAfterPaint = void 0;
    Object.defineProperty(exports, "executeAfterPaint", { enumerable: true, get: function () { return BaseView_2.executeAfterPaint; } });
    var TRACE_ENABLED = false;
    function WidgetSpec(target) {
        var WidgetSpec = function (props, context) {
            target.apply(this, arguments);
        };
        __extends(WidgetSpec, target);
        ObjectExtensions.overrideMethod(WidgetSpec.prototype, "componentDidMount", WidgetSpec.prototype.internalComponentDidMount);
        ObjectExtensions.overrideMethod(WidgetSpec.prototype, "componentDidUpdate", WidgetSpec.prototype.internalComponentDidUpdate);
        ObjectExtensions.overrideMethod(WidgetSpec.prototype, "UNSAFE_componentWillMount", WidgetSpec.prototype.internalComponentWillMount);
        ObjectExtensions.overrideMethod(WidgetSpec.prototype, "componentWillUnmount", WidgetSpec.prototype.internalComponentWillUnmount);
        ObjectExtensions.overrideMethod(WidgetSpec.prototype, "UNSAFE_componentWillUpdate", WidgetSpec.prototype.internalComponentWillUpdate);
        ObjectExtensions.overrideMethod(WidgetSpec.prototype, "render", WidgetSpec.prototype.internalRender);
        WidgetSpec.displayName = target.name;
        WidgetSpec.__hasWidgetSpec = true;
        return WidgetSpec;
    }
    exports.WidgetSpec = WidgetSpec;
    var Widget = (function (_super) {
        tslib_1.__extends(Widget, _super);
        function Widget(props, context) {
            var _this = _super.call(this, props, context) || this;
            _this.ref = React.createRef();
            var currentType = _this.constructor;
            _this.exception = null;
            _this.isDisposed = false;
            if (!currentType.__hasWidgetSpec) {
                throw new Error("Invalid widget. The widget must be decorated with WidgetSpec.");
            }
            if (_this.props._dependencies) {
                _this._generationNode = context.ancestorGenerationNode.addChild();
            }
            return _this;
        }
        Widget.prototype.getChildContext = function () {
            return {
                ancestorGenerationNode: this._generationNode
                    ? this._generationNode
                    : this.context.ancestorGenerationNode,
                locale: this.context.locale,
            };
        };
        Widget.prototype.componentDidMount = function () {
        };
        Widget.prototype.internalComponentDidMount = function (originalMethod) {
            originalMethod.apply(this);
            _super.prototype.componentDidMount.call(this);
            if (this.customComponentDidMountHandler) {
                this.customComponentDidMountHandler();
            }
        };
        Widget.prototype.UNSAFE_componentWillMount = function () {
        };
        Widget.prototype.internalComponentWillMount = function (originalMethod) {
            originalMethod.apply(this);
        };
        Widget.prototype.componentDidUpdate = function () {
        };
        Widget.prototype.internalComponentDidUpdate = function (originalMethod, args) {
            originalMethod.apply(this, args);
            _super.prototype.componentDidUpdate.call(this);
            if (this.customComponentDidUpdateHandler) {
                this.customComponentDidUpdateHandler();
            }
        };
        Widget.prototype.componentWillUnmount = function () {
        };
        Widget.prototype.internalComponentWillUnmount = function (originalMethod) {
            originalMethod.apply(this);
            _super.prototype.componentWillUnmount.call(this);
            this.isDisposed = true;
            if (this.customComponentWillUnmountHandler) {
                this.customComponentWillUnmountHandler();
            }
        };
        Widget.prototype.internalComponentWillUpdate = function (originalMethod, args) {
            originalMethod.apply(this, args);
            if (this.customComponentWillUpdateHandler) {
                this.customComponentWillUpdateHandler();
            }
        };
        Object.defineProperty(Widget.prototype, "skipRenderWhenHidden", {
            get: function () {
                return true;
            },
            enumerable: false,
            configurable: true
        });
        Widget.prototype.internalRender = function (originalMethod) {
            if (!this.skipRenderWhenHidden || this.props.visible === undefined || this.props.visible === true) {
                return originalMethod.apply(this);
            }
            else {
                return null;
            }
        };
        Widget.formatCssPropertyName = function (name) {
            name = name.replace(/-([\da-z])/gi, function (all, letter) { return letter.toUpperCase(); });
            if (/^(?:Webkit|Moz|O)[A-Z]/.test(name)) {
                return name;
            }
            return name.substring(0, 1).toLowerCase() + name.substring(1);
        };
        Widget.fillWithStyleProperties = function (inlineStyle, style) {
            var properties = inlineStyle.split(";");
            properties.forEach(function (property) {
                var propertyValueSeparatorIdx = property.indexOf(":");
                if (propertyValueSeparatorIdx > 0) {
                    var name_1 = property.substr(0, propertyValueSeparatorIdx).trim();
                    var value = property.substr(propertyValueSeparatorIdx + 1).trim();
                    var cssPropertyName = Widget.formatCssPropertyName(name_1);
                    style[cssPropertyName] = Utils_1.StringUtils.safeParseInt(value);
                }
            });
        };
        Widget.prototype.fillWithBuiltinProperties = function (attributes) {
            attributes.style = attributes.style || {};
            attributes.ref = this.ref;
            var gridProps = this.props.gridProperties;
            if (gridProps) {
                if (gridProps.classes) {
                    if (attributes.className) {
                        attributes.className = attributes.className + " " + gridProps.classes;
                    }
                    else {
                        attributes.className = gridProps.classes;
                    }
                }
                var styleAttr = attributes.style;
                if (gridProps.width) {
                    styleAttr.width = Utils_1.StringUtils.safeParseInt(gridProps.width);
                }
                if (gridProps.marginLeft) {
                    styleAttr.marginLeft = Utils_1.StringUtils.safeParseInt(gridProps.marginLeft);
                }
            }
            var extendedProperties = this.props.extendedProperties;
            if (extendedProperties) {
                for (var extendedPropertyName in extendedProperties) {
                    if (extendedPropertyName !== Widget.StyleAttribute) {
                        attributes[extendedPropertyName.valueOf()] = extendedProperties[extendedPropertyName];
                    }
                }
                var style = extendedProperties[Widget.StyleAttribute];
                if (style) {
                    Widget.fillWithStyleProperties(style, attributes.style);
                }
            }
            var extendedEvents = this.props.extendedEvents;
            if (extendedEvents) {
                for (var extendedEventName in extendedEvents) {
                    var event_1 = extendedEvents[extendedEventName];
                    switch (extendedEventName.toLowerCase()) {
                        case "componentdidmount":
                            this.customComponentDidMountHandler = event_1;
                            break;
                        case "componentdidupdate":
                            this.customComponentDidUpdateHandler = event_1;
                            break;
                        case "unsafe_componentwillupdate":
                        case "componentwillupdate":
                            this.customComponentWillUpdateHandler = event_1;
                            break;
                        case "componentwillunmount":
                            this.customComponentWillUnmountHandler = event_1;
                            break;
                        default:
                            attributes[extendedEventName.valueOf()] = event_1;
                            break;
                    }
                }
            }
        };
        Widget.prototype.hasOrWillHaveChildren = function (nextProps) {
            if (nextProps.placeholders) {
                return true;
            }
            if (React.Children.count(this.props.children) > 0 || React.Children.count(nextProps.children) > 0) {
                return true;
            }
            return false;
        };
        Object.defineProperty(Widget.prototype, "displayName", {
            get: function () {
                return this.constructor.displayName;
            },
            enumerable: false,
            configurable: true
        });
        Widget.prototype.shouldComponentUpdate = function (nextProps, nextState, nextContext) {
            if (!nextProps._dependencies && this.hasOrWillHaveChildren(nextProps)) {
                if (TRACE_ENABLED) {
                    console.log("Widget " + this.displayName + " is not optimized");
                }
                return true;
            }
            if (this._generationNode && !nextContext.isGenerationUpToDate(this._generationNode.generation)) {
                if (TRACE_ENABLED) {
                    console.log("Generation node of " + this.displayName + " changed");
                }
                return true;
            }
            if (!ObjectExtensions.arrayShallowEquals(this.props._dependencies, nextProps._dependencies)) {
                if (TRACE_ENABLED) {
                    console.log("Dependencies of " + this.displayName + " changed from: [ " + this.props._dependencies + " ] to: [ " + nextProps._dependencies + " ]");
                }
                return true;
            }
            if (!ObjectExtensions.shallowEquals(this.props, nextProps, Widget.affectsRender)) {
                if (TRACE_ENABLED) {
                    console.log("Properties of " + this.displayName + " changed from: [ " + this.props + " ] to: [ " + nextProps + " ]");
                }
                return true;
            }
            if (!ObjectExtensions.shallowEquals(this.state, nextState)) {
                if (TRACE_ENABLED) {
                    console.log("State of " + this.displayName + " changed from: [ " + this.state + " ] to: [ " + nextState + " ]");
                }
                return true;
            }
            if (!ObjectExtensions.shallowEquals(this.props.extendedProperties, nextProps.extendedProperties)) {
                if (TRACE_ENABLED) {
                    console.log("Extended Properties of " + this.displayName + " changed from: [ " + this.props.extendedProperties + " ] to: [ " + nextProps.extendedProperties + " ]");
                }
                return true;
            }
            if (this.context.locale !== nextContext.locale) {
                return true;
            }
            return false;
        };
        Widget.affectsRender = function (obj, propertyName) {
            if (propertyName.charAt(0) === "_") {
                return false;
            }
            switch (propertyName) {
                case "children":
                case "placeholders":
                case "gridProperties":
                case "extendedEvents":
                    return false;
                case "extendedProperties":
                    return false;
                default:
                    var propertyValue = obj[propertyName];
                    var propertyValueType = typeof propertyValue;
                    if (propertyValueType === "string" ||
                        propertyValueType === "number" ||
                        propertyValueType === "boolean") {
                        return true;
                    }
                    if (propertyValue) {
                        var hasFastEquals = propertyValue.fastEquals instanceof Function;
                        if (hasFastEquals) {
                            return true;
                        }
                        if (propertyValue.equals instanceof Function) {
                            console.warn("Consider implementing fastEquals for improved performance when comparing type: " +
                                propertyValue.constructor.name);
                            return true;
                        }
                    }
                    return false;
            }
        };
        Widget.prototype.executeAfterPaint = function (action) {
            var _this = this;
            BaseView_1.executeAfterPaint(function () {
                if (!_this.isDisposed) {
                    action();
                }
            });
        };
        Widget.prototype.executeWithActiveClassOn = function (action) {
            var _this = this;
            var activeClass = "active";
            var domNode = this.getHTMLNode();
            domNode.classList.add(activeClass);
            var result;
            try {
                result = action();
            }
            finally {
                var removeClass = function () {
                    if (!_this.isDisposed) {
                        domNode.classList.remove(activeClass);
                    }
                };
                if (result instanceof Promise) {
                    result.then(removeClass).catch(removeClass);
                }
                else {
                    removeClass();
                }
            }
        };
        Widget.prototype.getHTMLNode = function () {
            var element = this.ref.current;
            return this.findDOMNode(element !== null && element !== void 0 ? element : this);
        };
        Widget.StyleAttribute = "style";
        Widget.contextTypes = ObjectExtensions.assign({
            isGenerationUpToDate: PropTypes.func,
            ancestorGenerationNode: PropTypes.object,
            locale: PropTypes.string,
        }, BaseView_1.ViewComponent.contextTypes);
        Widget.childContextTypes = {
            ancestorGenerationNode: PropTypes.object,
            locale: PropTypes.string,
        };
        return Widget;
    }(BaseView_1.ViewComponent));
    exports.Widget = Widget;
    var ValidationWidget = (function (_super) {
        tslib_1.__extends(ValidationWidget, _super);
        function ValidationWidget(props, context) {
            var _this = _super.call(this, props, context) || this;
            if (!_this._generationNode) {
                _this._generationNode = context.ancestorGenerationNode.addChild();
            }
            return _this;
        }
        Object.defineProperty(ValidationWidget.prototype, "validationServiceProperties", {
            get: function () {
                return this.props._validationProps;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(ValidationWidget.prototype, "validationParentId", {
            get: function () {
                var validationServiceProps = this.validationServiceProperties;
                if (validationServiceProps) {
                    return validationServiceProps.validationParentId;
                }
                return null;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(ValidationWidget.prototype, "isValidationAggregator", {
            get: function () {
                return false;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(ValidationWidget.prototype, "isWebBlockInstance", {
            get: function () {
                return false;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(ValidationWidget.prototype, "validationService", {
            get: function () {
                var validationServiceProps = this.validationServiceProperties;
                if (validationServiceProps) {
                    return validationServiceProps.validationService;
                }
                return null;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(ValidationWidget.prototype, "isMandatory", {
            get: function () {
                return false;
            },
            enumerable: false,
            configurable: true
        });
        ValidationWidget.prototype.validate = function () {
            return new Validation_1.ValidationResult();
        };
        ValidationWidget.prototype.internalComponentWillMount = function (originalMethod) {
            _super.prototype.internalComponentWillMount.call(this, originalMethod);
            if (this.validationService) {
                this.validationService.register(this);
            }
        };
        ValidationWidget.prototype.internalComponentWillUnmount = function (originalMethod) {
            _super.prototype.internalComponentWillUnmount.call(this, originalMethod);
            if (this.validationService) {
                this.validationService.unregister(this.getId());
            }
        };
        Object.defineProperty(ValidationWidget.prototype, "widgetRecordProvider", {
            get: function () {
                return this.props._widgetRecordProvider;
            },
            enumerable: false,
            configurable: true
        });
        ValidationWidget.prototype.getValidationRecord = function () {
            return this.widgetRecordProvider.getReadOnlyWidgetRecord(this.getId());
        };
        Object.defineProperty(ValidationWidget.prototype, "generationNode", {
            get: function () {
                return this._generationNode;
            },
            enumerable: false,
            configurable: true
        });
        ValidationWidget.prototype.createValidationElement = function () {
            if (this.hasValidationMessage()) {
                return React.createElement(HtmlTags_1.HtmlTags.span, {
                    id: this.getId() + ValidationWidget.DescribedBySuffix,
                    className: "validation-message",
                }, this.getValidationRecord().validationMessageAttr);
            }
            return null;
        };
        ValidationWidget.prototype.hasValidationMessage = function () {
            var validationRecord = this.getValidationRecord();
            return !validationRecord.validAttr && validationRecord.validationMessageAttr !== "";
        };
        ValidationWidget.prototype.fillWithBuiltinProperties = function (attributes) {
            _super.prototype.fillWithBuiltinProperties.call(this, attributes);
            if (this.hasValidationMessage()) {
                attributes.className =
                    attributes.className === undefined ? "not-valid" : attributes.className + " not-valid";
            }
        };
        ValidationWidget.DescribedBySuffix = "_DescribedBy";
        return ValidationWidget;
    }(Widget));
    exports.ValidationWidget = ValidationWidget;
    var InputWithVariableWidget = (function (_super) {
        tslib_1.__extends(InputWithVariableWidget, _super);
        function InputWithVariableWidget() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Object.defineProperty(InputWithVariableWidget.prototype, "variable", {
            get: function () {
                throw new Error("InputWithVariableWidget.variable not implemented");
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(InputWithVariableWidget.prototype, "inputedValue", {
            get: function () {
                throw new Error("InputWithVariableWidget.inputedValue not implemented");
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(InputWithVariableWidget.prototype, "inputedValueValidity", {
            get: function () {
                return {
                    valid: true,
                    badInput: false,
                };
            },
            enumerable: false,
            configurable: true
        });
        InputWithVariableWidget.prototype.isTextVariable = function (variable) {
            switch (variable.type) {
                case DataTypes_1.DataTypes.Text:
                case DataTypes_1.DataTypes.Email:
                case DataTypes_1.DataTypes.PhoneNumber:
                    return true;
                default:
                    return false;
            }
        };
        InputWithVariableWidget.prototype.shouldUpdateValue = function (nextVariable) {
            var isValueChanged = !DataTypes_1.equals(this.variable.value, nextVariable.value);
            if (!isValueChanged) {
                return false;
            }
            var isNotDefaultValue = !DataConversion_1.JSConversions.isDefault(nextVariable.value);
            var isTextVariable = this.isTextVariable(this.variable);
            var validInputedValue = !this.inputedValueValidity || this.inputedValueValidity.valid;
            return isNotDefaultValue || isTextVariable || validInputedValue;
        };
        InputWithVariableWidget.prototype.isValueReallyEmpty = function () {
            var value = this.inputedValue;
            if (!InputWithVariableWidget.isEmptyValue(value)) {
                return false;
            }
            if (this.inputedValueValidity.badInput) {
                return false;
            }
            return true;
        };
        InputWithVariableWidget.prototype.validate = function () {
            var result = _super.prototype.validate.call(this);
            if (result.valid === false) {
                return result;
            }
            if (this.isValueReallyEmpty()) {
                if (this.isMandatory) {
                    return new Validation_1.ValidationResult(false, this.validationService.getMandatoryValueMessage());
                }
            }
            else if ((this.inputedValueValidity && !this.inputedValueValidity.valid) ||
                !this.variable.isAcceptable(this.inputedValue)) {
                return new Validation_1.ValidationResult(false, this.validationService.getInvalidValueMessage(this.variable.type));
            }
            return result;
        };
        InputWithVariableWidget.isEmptyValue = function (value) {
            return value === undefined || value === null || value === "" || (value.trim && value.trim() === "");
        };
        return InputWithVariableWidget;
    }(ValidationWidget));
    exports.InputWithVariableWidget = InputWithVariableWidget;
    var PlaceholderContent = (function () {
        function PlaceholderContent(renderPlaceholder) {
            this.renderPlaceholder = renderPlaceholder;
        }
        Object.defineProperty(PlaceholderContent, "Empty", {
            get: function () {
                return PlaceholderContent._empty;
            },
            enumerable: false,
            configurable: true
        });
        PlaceholderContent.prototype.render = function () {
            return WidgetHelpers_1.wrapElements(this.renderPlaceholder());
        };
        PlaceholderContent._empty = new PlaceholderContent(function () { return null; });
        return PlaceholderContent;
    }());
    exports.PlaceholderContent = PlaceholderContent;
    var ImmutableContextError = (function (_super) {
        tslib_1.__extends(ImmutableContextError, _super);
        function ImmutableContextError(messageDetail) {
            var _this = _super.call(this, "Widget iteration contexts are immutable: " + messageDetail) || this;
            _this.messageDetail = messageDetail;
            return _this;
        }
        return ImmutableContextError;
    }(Error));
    var WidgetIterationContext = (function () {
        function WidgetIterationContext(parentContext, list, currentRowNumber) {
            this.parentContext = parentContext;
            this.list = list;
            this.currentRowNumber = currentRowNumber;
        }
        WidgetIterationContext.prototype.getCurrentRowNumber = function (otherList) {
            if (otherList.modelId === this.list.modelId) {
                return this.currentRowNumber;
            }
            else {
                return this.parentContext.getCurrentRowNumber(otherList);
            }
        };
        WidgetIterationContext.prototype.clone = function () {
            var clonedContext = this.parentContext.clone();
            clonedContext.setCurrentRowNumber(this.list, this.currentRowNumber);
            return clonedContext;
        };
        WidgetIterationContext.prototype.isBeingIterated = function (list) {
            return false;
        };
        WidgetIterationContext.prototype.setCurrentRowNumber = function (list) {
            throw new ImmutableContextError("unable to set a new CurrentRowNumber");
        };
        WidgetIterationContext.prototype.registerIterationStart = function (list) {
            throw new ImmutableContextError("unable to register the start of a new iteration");
        };
        WidgetIterationContext.prototype.registerIterationEnd = function (list) {
            throw new ImmutableContextError("unable to register the end of an iteration");
        };
        WidgetIterationContext.prototype.getIterator = function (list) {
            throw new ImmutableContextError("unable to get an iterator state");
        };
        return WidgetIterationContext;
    }());
    var IteratorPlaceholderContent = (function () {
        function IteratorPlaceholderContent(renderItem, parentCallContext, parentIdService, ownerAlias) {
            if (parentIdService === void 0) { parentIdService = undefined; }
            if (ownerAlias === void 0) { ownerAlias = ""; }
            this.renderItem = renderItem;
            this.parentCallContext = parentCallContext;
            this.parentIdService = parentIdService;
            this.ownerAlias = ownerAlias;
            if (!parentCallContext) {
                throw new Error("Parent call context cannot be undefined");
            }
        }
        IteratorPlaceholderContent.prototype.render = function (ownerWidget, list, map, startIndex, length) {
            if (startIndex === void 0) { startIndex = 0; }
            if (length === void 0) { length = Number.MAX_VALUE; }
            if (!list) {
                return null;
            }
            if (!ownerWidget) {
                throw new Error("Owner widget cannot be null");
            }
            if (map) {
                var originalMap_1 = map;
                map = function (elements, listIndex) {
                    return originalMap_1(WidgetHelpers_1.wrapElements(elements, "i-" + listIndex), listIndex);
                };
            }
            else {
                map = function (elements, listIndex) {
                    return WidgetHelpers_1.wrapElements(elements, "i-" + listIndex);
                };
            }
            var itemContextCachePropName = this.getItemContextCachePropertyName();
            var itemContextCache = ownerWidget[itemContextCachePropName];
            if (!itemContextCache) {
                itemContextCache = {};
            }
            var newItemContextCache = {};
            var children = {};
            var listLength = Math.min(list.length, startIndex + length);
            for (var i = startIndex; i < listLength; i++) {
                var listItemId = list.idOf(i);
                var itemContext = this.createOrUpdateItemContext(list, listItemId, i, itemContextCache, newItemContextCache);
                var listItemIdService = new WidgetNaming_1.WidgetIdService(this.parentIdService, this.ownerAlias, WidgetNaming_1.NamespaceKind.IteratorItem, listItemId);
                children["i" + listItemId] = map(this.renderItem(listItemIdService, itemContext.callContext), i);
            }
            ownerWidget[itemContextCachePropName] = newItemContextCache;
            return React.createElement(React.Fragment, { key: "fragmentKey" }, Object.keys(children).map(function (key) { return React.createElement(React.Fragment, { key: key }, children[key]); }));
        };
        IteratorPlaceholderContent.prototype.createOrUpdateItemContext = function (list, listItemId, currentIndex, oldItemContextCache, newItemContextCache) {
            var newIterationContext = new WidgetIterationContext(this.parentCallContext.iterationContext, list, currentIndex);
            var itemContext = oldItemContextCache[listItemId];
            if (!itemContext) {
                itemContext = {
                    callContext: this.parentCallContext.clone(),
                };
            }
            itemContext.callContext.iterationContext = newIterationContext;
            itemContext.callContext.iterationContext = itemContext.callContext.clone().iterationContext;
            newItemContextCache[listItemId] = itemContext;
            return itemContext;
        };
        IteratorPlaceholderContent.prototype.getItemContextCachePropertyName = function () {
            return IteratorPlaceholderContent.ItemContextCachePropertyName + this.ownerAlias;
        };
        IteratorPlaceholderContent.ItemContextCachePropertyName = "__itemContextCache";
        return IteratorPlaceholderContent;
    }());
    exports.IteratorPlaceholderContent = IteratorPlaceholderContent;
});
//# sourceMappingURL=Widget.js.map;
